import { useState, useEffect, useContext } from 'react';

// Nucleus Components
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useLazyDataModel } from '@thd-nucleus/data-sources';

import { getReservation } from '../utils/api';
import { ReservationContext } from '../context/reservation-context';
import { FeatureSwitchContext } from '../context/feature-switch-context';
import { GET_RENTAL_RESERVATION_QUERY } from '../utils/queries';

export const useReservationLookupApi = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [isExecutable, setIsExecutable] = useState(true);

  const [reservationState, dispatch] = useContext(ReservationContext);
  const { reservationId } = reservationState;

  const { graphQlEnabled } = useContext(FeatureSwitchContext);

  const ctx = useContext(ExperienceContext);
  const { hosts } = ctx;
  const { apionline } = hosts || {};

  const variables = {
    reservationId: +reservationId
  };
  const [getRentalReservation] = useLazyDataModel('getRentalReservation', {
    variables,
    ssr: false,
  });

  const executeRequest = async () => {

    if (isExecutable) {
      setLoading(true);
      setIsExecutable(false);
      setError('');

      try {
        let result = null;

        if (graphQlEnabled) {
          const {
            data: rentalReservationData,
            error: rentalReservationError
          } = await getRentalReservation({ variables });

          if (rentalReservationError) {
            throw new Error(rentalReservationError);
          }
          result = rentalReservationData.getRentalReservation;
        } else {
          result = await getReservation({ host: apionline, reservationId });
        }

        setData(result);
      } catch (err) {
        setError(err.message || 'Unexpected Error');
        setData({});
        setIsExecutable(true);
      } finally {
        setLoading(false);
      }
    } else {
      setData({ ...data });
    }
  };

  useEffect(() => {
    if (!isExecutable) {
      setIsExecutable(true);
      setData({});
      setError('');
    }
  }, [reservationId, graphQlEnabled]);

  return {
    data,
    error,
    loading,
    executeRequest
  };
};

useReservationLookupApi.dataModel = GET_RENTAL_RESERVATION_QUERY;